import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  settings = new Subject<any[]>();

  constructor() {}

  getSettings(): Observable<any> {
    this.updateSettings();
    return this.settings.asObservable();
  }

  updateSettings() {
    this.settings.next(JSON.parse(localStorage.getItem('chatPageOptions')));
  }
}
